<div class="w-full flex justify-between">
  <button
    size="s"
    tuiButton
    [routerLink]="RouteNames.MAIN_PAGE">
    <b class="flex">
      <span>TRUST</span>
      CHECKER
    </b>
  </button>

  @if (isAuthenticated$ | async) {
    <button
      iconStart="@tui.layout-grid"
      size="s"
      tuiButton
      [routerLink]="RouteNames.HOME">
      <b>Консоль</b>
    </button>
  } @else {
    <button
      iconStart="@tui.user"
      size="s"
      tuiButton
      [routerLink]="RouteNames.LOGIN_PAGE">
      <b>Войти</b>
    </button>
  }
</div>
